// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import socialEntity from './entities/social.json';
import socialMenu from '../pages/social/menu.json';
import socialFullForm from '../pages/social/forms/full.json';
import socialContextForm from '../pages/social/forms/context.json';
import socialMiniForm from '../pages/social/forms/mini.json';
import socialLookupForm from '../pages/social/forms/lookup.json';
import socialCardsView from '../pages/social/views/cards.json';
import socialStagesView from '../pages/social/views/stages.json';
import socialBacklogView from '../pages/social/views/backlog.json';
import socialTableView from '../pages/social/views/table.json';
import socialCalendarView from '../pages/social/views/calendar.json';
import socialDashboardView from '../pages/social/views/dashboard.json';

/** Тип запису «Допис» зі сторінками пакета: меню, форми та подання з pages/social/. */
export const socialDefinition: IRecordTypeDefinition = {
  ...socialEntity,
  views: assembleViewSet({
      cards: socialCardsView,
      stages: socialStagesView,
      backlog: socialBacklogView,
      table: socialTableView,
      calendar: socialCalendarView,
      dashboard: socialDashboardView,
  }),
  form: socialFullForm,
  forms: { full: socialFullForm, context: socialContextForm, mini: socialMiniForm, lookup: socialLookupForm },
  menu: socialMenu,
} as IRecordTypeDefinition;
